
import useScrollAnimation from '../../../hooks/useScrollAnimation';

export default function PositioningStatement() {
  const ref = useScrollAnimation();

  return (
    <section ref={ref} id="about" className="relative py-32 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b7bab83ac5510acbea8405539a84f30c.jpg"
          alt="SkySails AI brand positioning"
          title="SkySails AI - Rising above operational noise"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-navy/80"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-8 lg:px-12 text-center">
        <div className="animate-on-scroll mb-8">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 mx-auto mb-8">
            <i className="ri-double-quotes-l text-2xl text-white/60"></i>
          </div>
        </div>
        <h2 className="animate-on-scroll text-3xl md:text-4xl lg:text-[44px] font-light text-white mb-8 leading-[1.3] tracking-tight" style={{ transitionDelay: '0.1s' }}>
          <strong>SkySails AI</strong> helps organizations rise above operational noise — delivering clarity, intelligent systems, and steady performance improvement.
        </h2>
        <p className="animate-on-scroll text-base md:text-lg text-white/50 font-light" style={{ transitionDelay: '0.2s' }}>
          Because better perspective leads to better decisions.
        </p>
      </div>
    </section>
  );
}
